export const QueryTags = {
  AccountingActivityLog: 'AccountingActivityLog',
  AccountingActivityLogApproval: 'AccountingActivityLogApproval',
  AccountingBankAccountList: 'AccountingBankAccountList',
  AccountingCustomerPayableSummary: 'AccountingCustomerPayableSummary',
  AccountingDepositTransactionList: 'AccountingDepositTransactionList',
  AccountingHotelShiftClosingList: 'AccountingHotelShiftClosingList',
  AccountingHotelShiftClosingTicket: 'AccountingHotelShiftClosingTicket',
  AccountingOpeningBalanceList: 'AccountingOpeningBalanceList',
  Accounting787MembersGroups: 'Accounting787MembersGroups',
  AccountingPartnerList: 'AccountingPartnerList',
  AccountingPayableReport: 'AccountingPayableReport',
  AccountingProviderList: 'AccountingProviderList',
  AccountingProviderPayableReport: 'AccountingProviderPayableReport',
  AccountingProviderPayableSummary: 'AccountingProviderPayableSummary',
  AccountingSalesReport: 'AccountingSalesReport',
  AccountingSalesReportTicket: 'AccountingSalesReportTicket',
  AccountingShiftClosingList: 'AccountingShiftClosingList',
  AccountingShiftClosingTicket: 'AccountingShiftClosingTicket',
  AccountingUserList: 'AccountingUserList',
  AclGroup: 'AclGroup',
  AclGroupList: 'AclGroupList',
  ACLPermissions: 'ACLPermissions',
  ApprovalTemplate: 'ApprovalTemplate',
  ApprovalTemplateDetail: 'ApprovalTemplateDetail',
  ApprovalTemplateOfSelectedProposalType:
    'ApprovalTemplateOfSelectedProposalType',
  Book: 'Book',
  Company: 'Company',
  CurrentUserProposals: 'CurrentUserProposals',
  DashboardStatistics: 'DashboardStatistics',
  Department: 'Department',
  DepartmentList: 'DepartmentList',
  DocumentAccessibility: 'DocumentAccessibility',
  DocumentBookGroups: 'DocumentBookGroups',
  FileQuery: 'FileQuery',
  HistoryLogList: 'HistoryLogList',
  InternalDocumentComments: 'InternalDocumentComments',
  InternalDocumentDetail: 'InternalDocumentDetail',
  IncomingInternalDocumentList: 'IncomingInternalDocumentList',
  OutgoingInternalDocumentList: 'OutgoingInternalDocumentList',
  IssuingAuthority: 'IssuingAuthority',
  ModuleQuery: 'ModuleQuery',
  MyDocumentList: 'MyDocumentList',
  SharedDocumentList: 'SharedDocumentList',
  Notifications: 'Notifications',
  NotificationUnreadCount: 'NotificationUnreadCount',
  News: 'News',
  NewsDetail: 'NewsDetail',
  NotiPermission: 'NotiPermission',
  Position: 'Position',
  ProposalComment: 'ProposalComment',
  ProposalDetail: 'ProposalDetail',
  ProposalType: 'ProposalType',
  SignAccounts: 'SignAccounts',
  SignedDocuments: 'SignedDocuments',
  DigitalSignatures: 'DigitalSignatures',
  UserAccounts: 'UserAccounts',
  UserDetail: 'UserDetail',
  UserCreditLimit: 'UserCreditLimit',
  UserModuleQuery: 'UserModuleQuery',
  UserTransactions: 'UserTransactions',
  ViewLogList: 'ViewLogList',
  VoteList: 'VoteList',
  WorkComments: 'WorkComments',
  WorkDetail: 'WorkDetail',
  WorkList: 'WorkList',
  WorkScheduleList: 'WorkScheduleList',
  WorkScheduleDetail: 'WorkScheduleDetail',
  WorkScheduleCompany: 'WorkScheduleCompany',
  ContentTemplateDetail: 'ContentTemplateDetail',
};
